import { render, staticRenderFns } from "./PersonalRights.vue?vue&type=template&id=ac5f1e5a&scoped=true"
import script from "./PersonalRights.vue?vue&type=script&lang=js"
export * from "./PersonalRights.vue?vue&type=script&lang=js"
import style0 from "./PersonalRights.vue?vue&type=style&index=0&id=ac5f1e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5f1e5a",
  null
  
)

export default component.exports